import { RELATION_ROLES } from 'src/services/mappings/relation/relation.const'
import type { PersonModel } from 'src/tpbp-json-api-handler/models/models'
import type { UserInfo } from './current-user.types'

export function getChildren(
  user: PersonModel,
  relations: PersonModel['_relations'],
  partner?: PersonModel,
) {
  const userChildren = getUserIdChildren(user.id, relations)
  const partnerChildren = partner
    ? getUserIdChildren(partner.id, relations)
    : []
  const commonChildren = getCommonChildren(userChildren, partnerChildren)
  return {
    userChildren,
    partnerChildren,
    commonChildren,
  }
}

export function getAllChildrenPerson(
  user: PersonModel,
  relations: PersonModel['_relations'],
  partner?: PersonModel,
) {
  const userIds = [user.id, partner?.id].filter(Boolean) as string[]
  return [
    ...new Set(
      filteredChildrenRelations(userIds, relations).map(
        ({ _subject }) => _subject,
      ),
    ),
  ]
}

function filteredChildrenRelations(
  userIds: string[],
  relations: PersonModel['_relations'],
) {
  return relations.filter(
    (relation) =>
      relation.role === RELATION_ROLES.child &&
      userIds.includes(relation._relatedTo.id),
  )
}

function getUserIdChildren(
  userId: string,
  relations: PersonModel['_relations'],
) {
  return filteredChildrenRelations([userId], relations).map<UserInfo>(
    (relation) => ({
      id: relation._subject.id,
      lastName: relation._subject.lastName,
      firstName: relation._subject.firstName,
    }),
  )
}

function getCommonChildren(
  userChildren: UserInfo[],
  partnerChildren: UserInfo[],
) {
  return userChildren.filter(({ id }) =>
    partnerChildren.some((child) => child.id === id),
  )
}
